import React, { useState } from "react";
import styled from "styled-components";
import siteLogo from "../Assets/Townbell-new-svg-logo.svg";
import { RxCross1 } from "react-icons/rx";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { GoArrowUpRight } from "react-icons/go";
import { IoIosMenu } from "react-icons/io";
import { FaXTwitter } from "react-icons/fa6";
import amayraTrillium from "../Assets/about/at-home.png";
import amayraTrilliumStreet from "../Assets/about/at-street.png";

// First define all styled components before using them
const HeaderWrapper = styled.header`
  /* position: sticky;
  top: 0;
  left: 0; */
  z-index: 39;
  max-width: 100vw;
  width: 100%;
  font-family: "Plus Jakarta Sans", sans-serif;

`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  align-items: center;
  position: relative;
  z-index: 39;
  overflow: hidden;
`;

const MenuButton = styled.button`
  display: flex;
  align-items: center;
  border: 1px solid white;
  border-radius: 2px;
  padding: 0.5rem 1rem;
  background: none;
  color: white;
  font-size: 14px;
  font-weight: 700;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: white;
    color: black;
  }
  svg {
    font-size: 21px;
    font-weight: 300;
  }

  @media (max-width: 767px) {
    .small {
      display: none;
    }
  }
`;

const NavList = styled.ul`
  list-style: none;
  text-align: center;
  padding: 0;
  margin: 0;
  @media (max-width: 767px) {
    display: contents;
  }
`;

const NavItem = styled.li`
  margin: 1.5rem 0;
  font-weight: bold;
  transition: transform 0.3s ease;
  @media (max-width: 767px) {
    margin: 10px;
    width: 100%;
  }
`;

const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 20px;
  font-weight: 700;
  position: relative;
  transition: color 0.3s ease;

  &:hover {
    color: #ccc;
    background: transparent;
  }

  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

const Social = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 30px;
  font-weight: 600;

  svg {
    font-size: 35px;
    font-weight: 700;
    transition: transform 0.3s ease, color 0.3s ease;

    &:hover {
      transform: scale(1.1);
      color: #ccc;
    }
  }
`;

const Logo = styled.div`
  text-align: center;
  cursor: pointer;
  img {
    height: auto;
    filter: brightness(0) invert(1);
  }
`;

// Now define FullscreenNav after all components it references
const FullscreenNav = styled.nav`
    position: fixed;
  overflow:hidden;
    top: 0;
    left: 0;
    width: 100vw;
    min-height: 100vh;
    height: 100%;
  background: black;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 40px;
  z-index: 38;
  gap: 80px;

  /* Initial state (hidden) */
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  opacity: 0;

  /* Animation when menu is open */
  ${({ menuOpen }) =>
    menuOpen &&
    `
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    opacity: 1;
  `}

  transition: 
    clip-path 0.7s cubic-bezier(0.645, 0.045, 0.355, 1),
    opacity 0.5s ease;

  /* Delay the content fade-in slightly */
  ${NavList}, ${Social} {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.4s ease 0.3s, transform 0.4s ease 0.3s;
  }

  ${({ menuOpen }) =>
    menuOpen &&
    `
    ${NavList}, ${Social} {
      opacity: 1;
      transform: translateY(0);
    }
  `}

  @media (max-width: 768px) {
    gap: 0px;
    justify-content: center;
  }
`;

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  // Routes where header background should be black
  const blackHeaderRoutes = ["/privacy-policy", "/terms-of-service"];
  const isBlackHeader = blackHeaderRoutes.includes(location.pathname);

  const toggleMenu = () => {
    document.body.style.overflow = menuOpen ? "auto" : "hidden";
    setMenuOpen(!menuOpen);
  };

  let currentLogo = siteLogo;

  if (location.pathname === "/amayra-trillium") {
    currentLogo = amayraTrillium;
  } else if (location.pathname === "/amayra-trillium-street") {
    currentLogo = amayraTrilliumStreet;
  }
  return (
    <HeaderWrapper>
      <HeaderContainer
        className={`flex justify-between items-center px-4 py-2 transition-colors duration-300 
        ${isBlackHeader ? "bg-[#521a27] text-white" : "bg-transparent text-white"}`}
      >
        <MenuButton onClick={toggleMenu} className="flex items-center gap-2">
          {menuOpen ? (
            <>
              <span style={{ marginRight: "5px" }}>
                <RxCross1 />
              </span>{" "}
              <span className="small">MENU</span>
            </>
          ) : (
            <>
              <span style={{ marginRight: "5px" }}>
                <IoIosMenu />
              </span>{" "}
              <span className="small">MENU</span>
            </>
          )}
        </MenuButton>

        <Logo>
          <img
            src={currentLogo}
            alt="TownBell-Trillium-Logo"
            loading="lazy"
            decoding="async"
            onClick={() => navigate("/")}
            className="2xl:w-[120px] lg:w-[115px] w-[100px] py-2"
          />
        </Logo>
        <MenuButton onClick={() => navigate("/contact-us")}>
          <span className="small">INQUIRE</span>
          <GoArrowUpRight />
        </MenuButton>
      </HeaderContainer>

      <FullscreenNav menuOpen={menuOpen}>
        <NavList>
          <NavItem>
            <NavLink href="/about-townbell" onClick={toggleMenu}>
              ABOUT
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink href="/amayra-trillium" onClick={toggleMenu}>
              AMAYRA TRILLIUM
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/amayra-trillium-street" onClick={toggleMenu}>
              AMAYRA TRILLIUM STREET
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink href="/contact-us" onClick={toggleMenu}>
              CONTACT
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/" onClick={toggleMenu}>
              HOME
            </NavLink>
          </NavItem>
        </NavList>
        <Social>
          <span>Follow </span>
          <hr
            style={{ width: "100px", borderColor: "rgba(255,255,255,0.3)" }}
          />
          <NavLink
            href="https://www.facebook.com/profile.php?id=61579054784028"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram">
              <FaFacebook />
            </i>
          </NavLink>
          <NavLink
            href="https://www.instagram.com/town_bell/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram">
              <FaInstagram />
            </i>
          </NavLink>
          <NavLink
            href="https://www.youtube.com/@Town-Bell"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f">
              <FaYoutube />
            </i>
          </NavLink>
          <NavLink
            href="https://x.com/Townbell1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f">
              <FaXTwitter />
            </i>
          </NavLink>
        </Social>
      </FullscreenNav>
    </HeaderWrapper>
  );
};

export default Header;
